import type { MailboxInfo } from 'owa-client-types';
import type { MailFolder } from 'owa-graph-schema';
import type { ApplyConversationActionContext } from 'owa-mail-triage-action-utils';
import type { ActionSource } from 'owa-mail-store';
import type RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import type * as Schema from 'owa-graph-schema';
import { action } from 'satcheljs';

/**
 * Action dispatched when archive tag of a folder has been updated successfully
 */
export const onArchiveTagForFolderUpdateSuccess = action(
    'ON_ARCHIVE_TAG_FOR_FOLDER_UPDATE_SUCCESS',
    (folder: MailFolder, archiveTag: Schema.RetentionTagType) => ({ folder, archiveTag })
);

/**
 * Action dispatched when delete tag of a folder has been updated successfully
 */
export const onDeleteTagForFolderUpdateSuccess = action(
    'ON_DELETE_TAG_FOR_FOLDER_UPDATE_SUCCESS',
    (folder: MailFolder, deleteTag: Schema.RetentionTagType) => ({ folder, deleteTag })
);

/**
 * Action dispatched when retention tag of a conversations/items has been updated successfully
 */
export const onRetentionTagForItemsUpdateSuccess = action(
    'ON_RETENTION_TAG_FOR_ITEMS_UPDATE_SUCCESS',
    (tag: RetentionTagType, isArchiveTag: boolean, itemIds: string[]) => ({
        tag,
        isArchiveTag,
        itemIds,
    })
);

/**
 * Action to change retention tag for items
 */
export const onRetentionTagForItemsChanged = action(
    'ON_RETENTION_TAG_FOR_ITEMS_CHANGED',
    (
        isArchiveTag: boolean,
        tagValue: string,
        itemIds: string[],
        actionSource: ActionSource,
        mailboxInfo: MailboxInfo
    ) => ({
        isArchiveTag,
        tagValue,
        itemIds,
        actionSource,
        mailboxInfo,
    })
);

/**
 * Action to change retention tag for conversations
 */
export const onRetentionTagForConversationsChanged = action(
    'ON_RETENTION_TAG_FOR_CONVERSATIONS_CHANGED',
    (
        isArchiveTag: boolean,
        tagValue: string,
        folderId: string,
        conversationActionContexts: ApplyConversationActionContext[],
        itemIds: string[],
        actionSource: ActionSource,
        mailboxInfo: MailboxInfo
    ) => ({
        isArchiveTag,
        tagValue,
        folderId,
        conversationActionContexts,
        itemIds,
        actionSource,
        mailboxInfo,
    })
);
